import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierTargetRateList extends Layout {
    layoutheaderCarrierTargetRateList: LayoutHeader;
    sourceCarrierRate: DataSource;
    tableCarrierTargetRate: Table;
}
